import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { getFirestore } from "./firebase";

const useFirestoreUpdate = (collection, docId) => {
  const db = getFirestore();

  // Function to format the date
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  };

  const updateData = async (data) => {
    const inscriptosRef = doc(db, collection, docId);

    // Format the date before sending
    const formattedDate = formatDate(Date.now());

    // Firebase no acepta undefined - reemplazar por null o ""
    const sanitize = (obj) => {
      const result = {};
      for (const [key, value] of Object.entries(obj)) {
        result[key] = value === undefined ? null : value;
      }
      return result;
    };

    const newEntry = sanitize({
      ...data,
      createdAt: formattedDate,
    });

    // Update Firestore document
    await updateDoc(inscriptosRef, {
      datos: arrayUnion(newEntry),
    });
  };

  return { updateData };
};

export default useFirestoreUpdate;
